import { useState } from 'react';

export const useTva = () => useState({ on: false, pct: 18 });
export const tvaPct = (tva) => (tva.on ? Number(tva.pct) || 0 : 0);
export const tvaAmount = (base, tva) => Math.round((Number(base) || 0) * tvaPct(tva) / 100);

const fmt = (n) => `${Math.round(Number(n) || 0).toLocaleString('fr-FR')} FCFA`;

export function TvaToggle({ tva, setTva, base, testid = 'tva' }) {
  return (
    <div className="rounded-lg border border-slate-200 bg-slate-50/70 px-3 py-2.5 space-y-2" data-testid={`${testid}-block`}>
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <span className="text-sm font-semibold text-slate-800">Appliquer la TVA ?</span>
        <div className="flex rounded-lg border border-slate-300 overflow-hidden text-sm font-semibold">
          {[[false, 'Sans TVA'], [true, 'Avec TVA']].map(([v, l]) => (
            <button key={l} type="button" onClick={() => setTva((t) => ({ ...t, on: v }))}
              className={`px-3 py-1.5 transition-colors ${tva.on === v ? 'bg-blue-600 text-white' : 'bg-white text-slate-600 hover:bg-slate-100'}`}
              data-testid={`${testid}-${v ? 'on' : 'off'}`}>{l}</button>
          ))}
        </div>
      </div>
      {tva.on && (
        <div className="flex items-center justify-between gap-3">
          <label className="flex items-center gap-2 text-sm text-slate-600">
            Taux
            <input type="number" min={0} max={100} step="0.5" value={tva.pct}
              onChange={(e) => setTva((t) => ({ ...t, pct: e.target.value }))}
              className="w-20 h-8 rounded-md border border-slate-300 px-2 text-right font-semibold" data-testid={`${testid}-pct`} />
            %
          </label>
          <span className="text-sm font-semibold text-slate-900" data-testid={`${testid}-amount`}>{fmt(tvaAmount(base, tva))}</span>
        </div>
      )}
    </div>
  );
}
